function adjustTimezone(date: Date, offset: string): Date {
  // Split the offset into hours and minutes
  const [hours, minutes] = offset.split(':').map(part => parseInt(part, 10))

  // Calculate the total offset in milliseconds
  // Note: The offset is subtracted because a positive offset means the timezone is ahead of UTC
  const offsetInMs = (hours * 60 + Math.sign(hours) * minutes) * 60 * 1000

  // Adjust the date by the offset and return the new date
  return new Date(date.getTime() - offsetInMs)
}

export default adjustTimezone
